<script>

    import * as api      from '../../shared/api.js'
    import { parseDate } from '../../shared/utils.js'

    export let item
    export let transition

    function transitionLabel(transition) {
        switch(transition.status) {
            case 'IDENTIFIED'        : return 'Pedido Identificado'
            case 'DENIED'            : return 'Pedido Negado'
            case 'EXECUTING'         : return 'Execução Iniciada'
            case 'GENERATING REPORT' : return 'Relatório Iniciado'
            case 'REPORT SUCCESS'    : return 'Relatório Finalizado'
            case 'REPORT AVAILABLE'  : return 'Relatório Disponível'
            case 'REPORT ERROR'      : return 'Erro ao Gerar Relatório'
            default: return transition.status
        }
    }

    $: enableDownload = transition.status === 'REPORT SUCCESS' || transition.status === 'REPORT AVAILABLE'
</script>
<style>
    .vlist {
        margin-bottom: .5em;
    }
    
    .vlist h6 {
        font-size: 1em;
        border: 0 !important;    
    }
</style>
<div class="vlist">
    <h6>    { transitionLabel(transition) } </h6>
    <div>em { parseDate(transition.at) }    </div>
    {#if enableDownload}
        <div>
            <a  href={api.resolve(`/inquiry/${item.inquiry.protocol}/report`)}>download</a>                                    
        </div>
    {/if}
</div>